// extracted by mini-css-extract-plugin
module.exports = {"root":"Drawer_root__PTjIr","left":"Drawer_left__O5cHF","right":"Drawer_right__2kki_"};